import { useStore } from '../store';

export const getUserProfile = () => {
  const { profile } = useStore.getState();
  return profile;
};

export const isUserLoggedIn = () => {
  const profile = getUserProfile();
  return !!profile?.id;
};

export const isUserAdministrator = () => {
  const profile = getUserProfile();
  return profile?.is_administrator ?? false;
};
